<template>
  <div class="header-wrap">

    <div class="header-left">
      <img class="logo" src="@/assets/logo/logo.png" alt="logo" />
<!--      <div class="user-info">
        <span class="link login" @click="login(1)">
          <img src="@/assets/login/user-login.png" class="user">
          <img src="@/assets/login/Login.png" class="img">
        </span>
      </div>-->
    </div>

    <div class="user-info">
      <!-- 账户余额 -->
      <div class="bottom">
        <div class="country-img">
          <img src="@/assets/logo/amount.png" />
        </div>
        <div class="count">
          {{ $store.state.visible === 4? $utils.changeMoney(0) :$utils.changeMoney($store.state.gold) }}
        </div>
      </div>
      <div class="sync-icon" @click="handleSync">
        <img :class="{ 'refresh-loading': spin }" src="@/assets/logo/refresh.png" />
      </div>
      <!-- 充值/提现按钮 -->
      <!--        <div class="button left">
                <img src="@/assets/logo/charge.png" class="purse" />
                <div class="charge" @click="goCharge">
                  {{ $t("Common.deposit") }}
                </div>
              </div>-->
    </div>

    <div class="header-right" @click="$router.push('mine')">
      <div class="user_info_id">
        <div class="avatar">
            <img src="@/assets/logo/avatar/picture11.png" class="avatar_icon" />
            <img v-if="store.state.myLevel > 0" class="vip" :src="require('@/assets/logo/avatar/vip/avatar_vip'+store.state.myLevel+'.png')">
        </div>
        <div class="user-id">
          ID:{{ $store.state.userId }}
<!--          <Copy class="copy-icon" :txt="$store.state.userId + ''" />-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VipTag from "@/components/VipTag";
import store from "@/store";
import Copy from "@/components/Copy/index.vue";
export default {
  name: "topHeader",
  data() {
    return {
      spin: false,
      vipLevel: 0,
    };
  },
  components: {
    Copy,
    VipTag,
  },
  computed: {
    store() {
      return store
    },
    isLogin() {
      return this.$store.state.isLogin;
    },
  },
  watch: {},
  created() {
    this.handleSync();
  },
  activated() {},
  methods: {
    goCharge() {
      this.$store.commit("setLoginCallBack", () => {
        this.$store.commit("setPayModalVisible", true);
      });
      this.$store.dispatch("handleCheckLogin");
    },
    handleSync() {
      this.$store.commit("getRefreshBalance", true);
      this.spin = true;
      setTimeout(() => {
        this.spin = false;
      }, 1000);
    },
    login(type) {
      this.$store.state.loginType = type;
      this.$store.dispatch("handleCheckLogin");
    },
  },
};
</script>

<style lang="less" scoped>
@import "./pc.less";
@media only screen and (max-width: @screen-width4) {
  @import "./h5.less";
}
</style>
